import axios from 'axios';
import { JWT } from '../../config';
import { getApiUrl } from '../../lib/function';
import { AuthConstant, ProgramConstant, AlertConstant } from '../reducer';
import { Store } from '../../store';
import { GroupAction } from './GroupAction';

const RayLinkHeaderNoAuth = {
	'x-ray-device': 'RAYLINK'
};

const Login = (data) => async (dispatch) => {
	const API_URL = getApiUrl('user');
	dispatch({ type: ProgramConstant.API_REQUEST });
	const ret = await axios.post(API_URL + '/login', { data }, JWT());
	dispatch({ type: ProgramConstant.API_RESPONSE });
	
	if (ret.data.status === 'success') {
		if (ret.data.data?.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
			dispatch({ type: AuthConstant.SET_FIRST_SIGNIN_DATA, item: {...data, ...ret.data.data} });
			history.push('/Login/first');
			return ret.data;
		}

		if(ret.data.data.serverId)
			localStorage.setItem('serverId', ret.data.data.serverId);
			
		var udatajson = ret.data.data.user;
		udatajson = {...udatajson, utype : udatajson.utype || ["manager"]};
		var udata = JSON.stringify(udatajson);		

		localStorage.setItem('user', udata);
		localStorage.setItem('userToken', ret.data.data.jwt);
		localStorage.setItem('MYLAB_AUTH_REFRESHTOKEN', ret.data.data.token.RefreshToken);
		localStorage.setItem('RAYLINK_USER_EMAIL', udatajson.email);
		localStorage.setItem('AUTO_LOGIN', data.autoLogin ? "Y" : "");
		
		dispatch({ type: AuthConstant.LOGIN_SUCCESS, user: udatajson, userToken: ret.data.data.jwt });
		dispatch({ type: AlertConstant.NOTICE, data: "Success" });		
	} else {
		dispatch({ type: AlertConstant.ERROR, data: ret.data.err });
	}
	return ret.data;
};

const Logout = () => (dispatch) => {
	localStorage.removeItem('user');
	localStorage.removeItem('userToken');
	localStorage.removeItem('refreshToken');
	localStorage.removeItem('RAYLINK_USER_ID');
	localStorage.removeItem('RAYLINK_USER_EMAIL');
	localStorage.removeItem('MYLAB_AUTH_USER');
	localStorage.removeItem('MYLAB_AUTH_REFRESHTOKEN');
	localStorage.removeItem('AUTO_LOGIN');
	localStorage.removeItem('MYLAB_AUTH_TOKEN');
	localStorage.removeItem('RAYLINK_GROUPID');

	dispatch({ type: AuthConstant.LOGOUT });
};

const CreateIuBendaConsent = async (data) => {	
	const headers = { ApiKey: '4paJj3dzSvRYPlF7aGejmVzLtzHqKLi4' };
	await axios.post('https://consent.iubenda.com/consent/', data, { headers });
}

export const AuthAction = {
	Login,
	Logout,
	CreateIuBendaConsent
};
